import type { UIAction, UIAPIRequestAction } from "@huub-web/ui";

/**
 * If the action is an `apiRequest`, returns a copy with `value` injected into
 * the nested `payload.payload` object. Otherwise returns the action unchanged.
 */
export const buildApiRequestValueAction = ({
  action,
  value,
}: {
  action: UIAction;
  value: unknown;
}): UIAction => {
  if (action.type !== "apiRequest") return action;

  const apiAction = action as UIAPIRequestAction;
  return {
    type: "apiRequest",
    payload: {
      ...apiAction.payload,
      payload: {
        ...apiAction.payload?.payload,
        value,
      },
    },
  } as UIAPIRequestAction;
};
